import { ReactElement } from 'react';
import { useTheme } from '../../Styles/themed-styled-components';

import { SvgIconProps } from '../../Components/Icons';

export function LogoBreatheLifeSmallIcon(props: SvgIconProps): ReactElement {
  const { fill: fillProp, width: widthProp, height: heightProp, id } = props.svgProps;

  const theme = useTheme();
  const width = widthProp ?? '16';
  const height = heightProp ?? '19';
  const fill = fillProp ?? theme.colors.grey[50];
  const titleId = `title-${id}`;

  return (
    <svg
      id={id}
      role='img'
      aria-label='Breathe Life'
      fill={fill}
      height={height}
      viewBox='0 0 429 600'
      width={width}
      xmlns='http://www.w3.org/2000/svg'
      aria-labelledby={id ? titleId : undefined}
    >
      <g>
        {id && props.title && <title id={titleId}>{props.title}</title>}
        <path
          d='M202.8,599.8c-24.7,0-47.2-6.7-65.3-19.4c-27-19-39-42.7-39-76.9c0-54.9,57.9-132.3,186.7-132.3
		c27.1,0,66.4,16.3,66.8,16.5l1,0.4l0.6,0c3.7,0.9,34.5,9.5,55,15.2l0.8,0.2l18.3-6.4c0.6,4.5-2.1,13.5-3.8,16.9
		c-13,25.9-60.3,113.8-124.5,156c-7,4.6-14,8.5-21,11.8c-24.3,11.2-48.1,17.3-70.8,18.1C206,599.7,204.4,599.8,202.8,599.8
		L202.8,599.8z M275.8,394.9c-50.2,0-118.4,19.9-145.1,76.1c-10,21-10.7,43.6-1.9,62c13.6,28.4,36.7,41.7,72.8,41.7
		c1.8,0,3.6,0,5.5-0.1c19-0.7,39.5-6,60.8-15.9c63.5-29.4,112.6-112.2,126.2-141.6l2.5-5.4l-5.8-1.1c-4-0.7-8.7-1.7-14.1-2.8
		C351.8,402.7,314.3,394.9,275.8,394.9z'
        />
        <path
          d='M194,476c-18,0-36.3-1.5-49-4.1C94,461.6,53.6,439.4,28.2,407.8c-23.3-29-32.3-63.6-25.4-97.5c9-44.3,50.2-96.7,136.8-98.9
		c1.8,0,3.6-0.1,5.4-0.1c16.4,0,33.9,1.8,51.9,5.5c99.3,20.1,196.1,128.1,223.4,160.7c4.3,5.1,2.4,34.5,2.4,34.5s-4.4,1.9-7,3
		C395.2,425.2,288.1,476,194,476z M145.8,236.6c-1.6,0-3.2,0-4.8,0.1c-24.7,0.6-46.5,6-64.9,15.9c-2.7,1.5-5.4,3.1-8,4.8
		c-21.8,14.2-35.8,34.2-40.6,58c-5.4,26.4,2.3,54.7,21,77.6c21.6,26.5,56.7,45.3,101.6,54.4c12,2.4,37.5,3.5,44,3.5
		c88.3,0,191.9-49.2,203.4-54.8l4.5-1.8l-5.9-6.2l-1.7-1.9c-32.7-37.7-117.9-127.3-202.6-144.5C175.8,238.2,160.3,236.6,145.8,236.6
		z'
        />
        <path
          d='M409.8,414.7c-1.6-0.1-7.1-0.4-12.8-1.5c-52.5-10.2-152.7-35.3-234.3-88.5C83.9,273.3,44,210.1,44,136.9
		C44,62.8,109.3,0.2,186.7,0.2c84.4,0,149,46.4,191.8,137.8c45.1,96.2,49.9,207.8,49.9,251.3c0,9.4,0.8,16.9-4,21.8
		C422.2,413.5,415.1,414.9,409.8,414.7z M186.7,26.4c-63.9,0-112,47.5-112,110.5c0,166.6,248.9,235.9,325.1,253.1l5.6,1.3v-5.8
		C405.4,246.7,343.8,26.4,186.7,26.4z'
        />
      </g>
    </svg>
  );
}
